export {
  DIGITS,
  ONLY_DIGITS,
  LOWERCASE,
  UPPERCASE,
  SPECIAL_CHARACTERS,
  REG_FULL_TRAILING_SLASH,
  REG_REJECTED_RESET_ERROR,
  HOUR_MINUTES
} from './regex';
